import {
  FaAppStore,
  FaBitbucket,
  FaCss3Alt,
  FaDocker,
  FaFigma,
  FaGitAlt,
  FaGithub,
  FaGitlab,
  FaGooglePlay,
  FaHtml5,
  FaJava,
  FaJira,
  FaLinux,
  FaNode,
  FaNpm,
  FaPython,
  FaReact,
  FaSass,
  FaSlack,
} from "react-icons/fa";
import { DiScrum } from "react-icons/di";
import { RiTeamFill } from "react-icons/ri";
import { BiLogoPostgresql } from "react-icons/bi";
import { MdOutlineDataObject } from "react-icons/md";
import {
  TbApi,
  TbBrandNextjs,
  TbBrandReactNative,
  TbBrandVscode,
} from "react-icons/tb";
import {
  SiCplusplus,
  SiExpress,
  SiFirebase,
  SiIntellijidea,
  SiJavascript,
  SiMongodb,
  SiPostman,
  SiRedux,
  SiSentry,
  SiSocketdotio,
  SiThealgorithms,
  SiTypescript,
} from "react-icons/si";

export const FULL_NAME = "Yakupguly Malikov";
export const POSITION = "Software Engineer";
export const HEADLINE =
  "React & React Native Developer | Building Seamless User Experiences";

export const SECTIONS = {
  ABOUT: "about",
  EXPERIENCE: "experience",
  SKILLS: "skills",
  CERTIFICATIONS: "certifications",
  PROJECTS: "projects",
};

export const ROUTES = {
  HOME: "/",
  ALL_PROJECTS: "/all-projects",
  ALL_CERTIFICATIONS: "/all-certifications",
};

export const SOCIAL_NETWORKS = {
  GITHUB: "https://github.com/Yakup3",
  LINKEDIN: "https://www.linkedin.com/in/yakupguly-malikov/",
  INSTAGRAM: "https://instagram.com/yakup.malikov",
  STACKOVERFLOW: "https://stackoverflow.com/users/20860690/yakup-malikov",
  LEETCODE: "https://leetcode.com/Yakup7/",
  HACKERRANK: "https://www.hackerrank.com/yakupmalikov7",
  CODEWARS: "https://www.codewars.com/users/Yakup7",
};

const commandAction = (section) => {
  const { top } = document.getElementById(section).getBoundingClientRect();
  window.scrollTo({ top: top + window.scrollY, behavior: "smooth" });
};

export const COMMANDS = [
  {
    command: "About",
    action: () => {
      commandAction(SECTIONS.ABOUT);
    },
  },
  {
    command: "Experience",
    action: () => {
      commandAction(SECTIONS.EXPERIENCE);
    },
  },
  {
    command: "Skills",
    action: () => {
      commandAction(SECTIONS.SKILLS);
    },
  },
  {
    command: "Certifications",
    action: () => {
      commandAction(SECTIONS.CERTIFICATIONS);
    },
  },
  {
    command: "Projects",
    action: () => {
      commandAction(SECTIONS.PROJECTS);
    },
  },
];

export const EXPERIENCE = [
  {
    company: "KiraPratik",
    position: "Software Engineer",
    period: {
      start: "Sep 2022",
      end: "Jan 2024",
    },
    description: [
      "Developed an ecommerce web application using Next.js framework, leveraging its capabilities to significantly improve website performance and enhance user experience.",
      "Spearheaded the development of the Cetele and KiraPratik mobile application using React Native, enabling landlords to effortlessly manage rent payments.",
      "Pioneered a comprehensive project plan for the Cetele and AidatPratik mobile applications, incorporating agile methodologies following the Scrum methodology and cross-functional collaboration.",
      "Managed the administration and publication of mobile applications on both the Apple App Store and Google Play Store.",
    ],
    tools: [
      "React Native",
      "React.js",
      "Next.js",
      "Redux",
      "JavaScript",
      "Jira",
      "Git",
      "Rest API",
      "React Hooks",
      "API Integration",
    ],
  },
  {
    company: "KiraPratik",
    position: "React Native Developer Intern",
    period: {
      start: "Jul 2022",
      end: "Sep 2022",
    },
    description: [
      "Implemented problem-solving techniques to identify and fix bugs in the mobile application which increased overall app performance.",
      "Successfully integrated third-party APIs into mobile applications, resulting in a seamless user experience and contributing.",
      "Maintained existing software applications by conducting regular code reviews and implementing necessary updates.",
    ],
    tools: [
      "React Native",
      "React.js",
      "Redux",
      "JavaScript",
      "Jira",
      "Git",
      "Rest API",
      "React Hooks",
      "API Integration",
    ],
  },
  {
    company: "Parabol",
    position: "Software Engineer",
    period: {
      start: "Aug 2021",
      end: "Jun 2023",
    },
    description: [
      "Conducted analysis and optimization of a TypeScript-based React Native application, while also introducing new features to elevate user engagement.",
      "Integrated a streamlined offline data processing system into the React Native-based application, resulting in a reduction in users' data loss even when offline.",
      "Contributed to the development of public transportation optimization using React, demonstrating expertise in front-end technologies and collaborative problem-solving for enhanced user experiences.",
    ],
    tools: [
      "React Native",
      "React.js",
      "TypeScript",
      "Redux",
      "JavaScript",
      "Git",
      "Socket.io",
      "Linux",
      "React Hooks",
      "API Integration",
    ],
  },
  {
    company: "Parabol",
    position: "Software Engineer Intern",
    period: {
      start: "Jun 2021",
      end: "Aug 2021",
    },
    description: [
      "Developed a scalable and efficient microservices-based RESTful API using Node.js, Express.js, and MongoDB, optimizing database operations for high performance. Also, implemented continuous integration and deployment processes using Docker,",
      "Architected and led the development of a Premier League Simulation application using React Native.",
      "Integrated real-time data updates into the app's standings table after each played match, providing users with up-to-date information and enhancing their overall experience.",
    ],
    tools: [
      "React Native",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Docker",
      "JavaScript",
      "Git",
      "Rest API",
      "RabbitMQ",
      "Socket.io",
      "API Integration",
    ],
  },
];

const iconColor = "var(--secondary-text-color)";
const iconSize = 30;

export const SKILLS = [
  {
    title: "Languages",
    items: [
      {
        name: "JavaScript",
        icon: <SiJavascript size={iconSize} color={iconColor} />,
      },
      {
        name: "TypeScript",
        icon: <SiTypescript size={iconSize} color={iconColor} />,
      },
      { name: "Java", icon: <FaJava size={iconSize} color={iconColor} /> },
      { name: "Python", icon: <FaPython size={iconSize} color={iconColor} /> },
      { name: "C++", icon: <SiCplusplus size={iconSize} color={iconColor} /> },
    ],
  },
  {
    title: "Libraries & Frameworks",
    items: [
      { name: "React", icon: <FaReact size={iconSize} color={iconColor} /> },
      {
        name: "React Native",
        icon: <TbBrandReactNative size={iconSize} color={iconColor} />,
      },
      {
        name: "Next.js",
        icon: <TbBrandNextjs size={iconSize} color={iconColor} />,
      },
      {
        name: "Express.js",
        icon: <SiExpress size={iconSize} color={iconColor} />,
      },
      { name: "Node.js", icon: <FaNode size={iconSize} color={iconColor} /> },
      { name: "Redux", icon: <SiRedux size={iconSize} color={iconColor} /> },
      {
        name: "React Hooks",
        icon: <FaReact size={iconSize} color={iconColor} />,
      },
      { name: "HTML", icon: <FaHtml5 size={iconSize} color={iconColor} /> },
      { name: "CSS", icon: <FaCss3Alt size={iconSize} color={iconColor} /> },
      { name: "SCSS", icon: <FaSass size={iconSize} color={iconColor} /> },
    ],
  },
  {
    title: "Tools & Platforms",
    items: [
      { name: "Git", icon: <FaGitAlt size={iconSize} color={iconColor} /> },
      { name: "GitHub", icon: <FaGithub size={iconSize} color={iconColor} /> },
      { name: "GitLab", icon: <FaGitlab size={iconSize} color={iconColor} /> },
      {
        name: "Bitbucket",
        icon: <FaBitbucket size={iconSize} color={iconColor} />,
      },
      { name: "Docker", icon: <FaDocker size={iconSize} color={iconColor} /> },
      { name: "Sentry", icon: <SiSentry size={iconSize} color={iconColor} /> },
      { name: "npm", icon: <FaNpm size={iconSize} color={iconColor} /> },
      {
        name: "MongoDB",
        icon: <SiMongodb size={iconSize} color={iconColor} />,
      },
      {
        name: "PostgreSQL",
        icon: <BiLogoPostgresql size={iconSize} color={iconColor} />,
      },
      {
        name: "Firebase",
        icon: <SiFirebase size={iconSize} color={iconColor} />,
      },
      {
        name: "Socket.io",
        icon: <SiSocketdotio size={iconSize} color={iconColor} />,
      },
      { name: "Linux", icon: <FaLinux size={iconSize} color={iconColor} /> },
      {
        name: "Visual Studio Code",
        icon: <TbBrandVscode size={iconSize} color={iconColor} />,
      },
      {
        name: "IntelliJ IDEA",
        icon: <SiIntellijidea size={iconSize} color={iconColor} />,
      },
      {
        name: "Postman",
        icon: <SiPostman size={iconSize} color={iconColor} />,
      },
      {
        name: "App Store",
        icon: <FaAppStore size={iconSize} color={iconColor} />,
      },
      {
        name: "Google Play",
        icon: <FaGooglePlay size={iconSize} color={iconColor} />,
      },
    ],
  },
  {
    title: "Other",
    items: [
      {
        name: "Data Structure & Algorithms",
        icon: <SiThealgorithms size={iconSize} color={iconColor} />,
      },
      {
        name: "Object-oriented programming",
        icon: <MdOutlineDataObject size={iconSize} color={iconColor} />,
      },
      {
        name: "RESTful API",
        icon: <TbApi size={iconSize} color={iconColor} />,
      },
      { name: "Slack", icon: <FaSlack size={iconSize} color={iconColor} /> },
      { name: "Figma", icon: <FaFigma size={iconSize} color={iconColor} /> },
      { name: "Jira", icon: <FaJira size={iconSize} color={iconColor} /> },
      { name: "Scrum", icon: <DiScrum size={iconSize} color={iconColor} /> },
      {
        name: "Team Work",
        icon: <RiTeamFill size={iconSize} color={iconColor} />,
      },
    ],
  },
];

export const CERTIFICATIONS = [
  {
    title: "JavaScript (Intermediate)",
    issuer: "HackerRank",
    issueDate: "Mar 2024",
    credentialId: "fc68b6d9ce1b",
    credentialUrl: "https://www.hackerrank.com/certificates/fc68b6d9ce1b",
  },
  {
    title: "JavaScript (Basic)",
    issuer: "HackerRank",
    issueDate: "Mar 2024",
    credentialId: "56fef88ef8f9",
    credentialUrl: "https://www.hackerrank.com/certificates/56fef88ef8f9",
  },
  {
    title: "React (Basic) ",
    issuer: "HackerRank",
    issueDate: "Mar 2024",
    credentialId: "ae8c7feb3cf4",
    credentialUrl: "https://www.hackerrank.com/certificates/ae8c7feb3cf4",
  },
  {
    title: "Intermediate Python",
    issuer: "DataCamp",
    issueDate: "May 2022",
    credentialId: "65e7a692bd82fca19e2212b0f01ea25b18db9b57",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/65e7a692bd82fca19e2212b0f01ea25b18db9b57",
  },
  {
    title: "Data Manipulation with pandas",
    issuer: "DataCamp",
    issueDate: "Mar 2023",
    credentialId: "66fecebaefa409a1450dab3d498c4c4477a12280",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/66fecebaefa409a1450dab3d498c4c4477a12280",
  },
  {
    title: "Problem Solving (Basic)",
    issuer: "HackerRank",
    issueDate: "Feb 2024",
    credentialId: "5ece1c02ffce",
    credentialUrl: "https://www.hackerrank.com/certificates/5ece1c02ffce",
  },
  {
    title: "SQL (Basic) ",
    issuer: "HackerRank",
    issueDate: "Mar 2024",
    credentialId: "6f51ce551884",
    credentialUrl: "https://www.hackerrank.com/certificates/6f51ce551884",
  },
  {
    title: "Node (Basic) ",
    issuer: "HackerRank",
    issueDate: "Mar 2024",
    credentialId: "ae8c7feb3cf4",
    credentialUrl: "https://www.hackerrank.com/certificates/ae8c7feb3cf4",
  },
  {
    title: "Intro to Operating Systems 2: Memory Management",
    issuer: "Coursera",
    issueDate: "Jun 2023",
    credentialId: "DBPURYDGPRPW",
    credentialUrl:
      "https://www.coursera.org/account/accomplishments/verify/DBPURYDGPRPW",
  },
  {
    title: "Intro to Operating Systems 1: Virtualization",
    issuer: "Coursera",
    issueDate: "Apr 2023",
    credentialId: "N4ZG6J3HQL2G",
    credentialUrl:
      "https://www.coursera.org/account/accomplishments/verify/N4ZG6J3HQL2G",
  },
  {
    title: "Analyzing Social Media Data in Python",
    issuer: "DataCamp",
    issueDate: "Jun 2022",
    credentialId: "f36f1b26d07d3cab5c4013e351a0fd2a0623f27f",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/f36f1b26d07d3cab5c4013e351a0fd2a0623f27f",
  },
  {
    title: "Intermediate Statistical Modeling in R",
    issuer: "DataCamp",
    issueDate: "Jun 2022",
    credentialId: "a9f1ac7f2becffe2a5c20a34fbc003eb6fd36fc9",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/a9f1ac7f2becffe2a5c20a34fbc003eb6fd36fc9",
  },
  {
    title: "Introduction to Data Science in Python",
    issuer: "DataCamp",
    issueDate: "Jun 2022",
    credentialId: "3d82adf501efaab72829168e78230e419d2e0d56",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/3d82adf501efaab72829168e78230e419d2e0d56",
  },
  {
    title: "Introduction to Importing Data in Python",
    issuer: "DataCamp",
    issueDate: "Jun 2022",
    credentialId: "dccb83b654f4519d5b6f0633897ca0c85570faf8",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/dccb83b654f4519d5b6f0633897ca0c85570faf8",
  },
  {
    title: "Introduction to Statistical Modeling in R",
    issuer: "DataCamp",
    issueDate: "Jun 2022",
    credentialId: "78bbad0a8ba318d00e7cf909cefc37eb760f473d",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/78bbad0a8ba318d00e7cf909cefc37eb760f473d",
  },
  {
    title: "Python Data Science Toolbox (Part 1)",
    issuer: "DataCamp",
    issueDate: "Jun 2022",
    credentialId: "dd7e85418fca01cef8edcec723548ebc4257e00a",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/dd7e85418fca01cef8edcec723548ebc4257e00a",
  },
  {
    title: "Statistical Thinking in Python (Part 1)",
    issuer: "DataCamp",
    issueDate: "Jun 2022",
    credentialId: "cd620a26e4ca531394cbfdb92f9d6379322e7050",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/cd620a26e4ca531394cbfdb92f9d6379322e7050",
  },
  {
    title: "Introduction to Python",
    issuer: "DataCamp",
    issueDate: "May 2022",
    credentialId: "2e81520a119994e44e3d945ce0a7dda93d1796b7",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/2e81520a119994e44e3d945ce0a7dda93d1796b7",
  },
  {
    title: "Introduction to R",
    issuer: "DataCamp",
    issueDate: "May 2022",
    credentialId: "01e242c7d2e1cd3b56e8cb74c189ae70ea578948",
    credentialUrl:
      "https://www.datacamp.com/statement-of-accomplishment/course/01e242c7d2e1cd3b56e8cb74c189ae70ea578948",
  },
];

export const PROJECTS = [
  {
    title: "AidatPratik",
    description: `Manage finances effortlessly with AidatPratik. Easily view income and expense tables, receive payment reminders, pay dues online, track dues seamlessly, enjoy a user-friendly interface, and efficiently manage expenses.`,
    liveUrl: "https://www.aidatpratik.com.tr/",
    githubUrl: null,
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.aidatpratik",
    appStoreUrl: "https://apps.apple.com/tr/app/aidatpratik/id6464537412",
    tools: [
      "React Native",
      "React.js",
      "JavaScript",
      "CSS",
      "Git",
      "Redux",
      "React Hooks",
      "API Integration",
    ],
  },
  {
    title: "Çetele",
    description: `Manage numerous estates easily with maps, reporting, and digital archive features—all in one mobile application. Add, report, and view property information effortlessly, whenever you need it.`,
    liveUrl: "https://www.kirapratik.com.tr/cetele/",
    githubUrl: null,
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.kirapratikcetelemobile",
    appStoreUrl: "https://apps.apple.com/tr/app/%C3%A7etele/id6449296827",
    tools: [
      "React Native",
      "React.js",
      "JavaScript",
      "CSS",
      "Git",
      "Redux",
      "React Hooks",
      "API Integration",
    ],
  },
  {
    title: "KiraPratik",
    description: `Track rent, manage properties, and access financial insights—all in one digital platform. With features like Financial Reporting, Smart Contracts, Renovation Services, Rent Guarantee, and more, KiraPratik streamlines property ownership for ultimate convenience.`,
    liveUrl: "https://www.kirapratik.com.tr/",
    githubUrl: null,
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=org.kirapratik.mobile",
    appStoreUrl: "https://apps.apple.com/tr/app/kirapratik/id1491051519",
    tools: [
      "React Native",
      "React.js",
      "JavaScript",
      "CSS",
      "Git",
      "Redux",
      "React Hooks",
      "API Integration",
    ],
  },
  {
    title: "Pintask",
    description: `Pintask allows you to coordinate, plan and follow up all your field work through a single map-based application`,
    liveUrl: "https://www.pintask.app/",
    githubUrl: null,
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.taskmanagementmobile",
    appStoreUrl: "https://apps.apple.com/tr/app/pintask/id1491461808",
    tools: [
      "React Native",
      "React.js",
      "JavaScript",
      "TypeScript",
      "CSS",
      "Git",
      "Socket.IO",
      "Redux",
      "React Hooks",
      "API Integration",
    ],
  },
  {
    title: "Canaria Scrapy",
    description: `This project is a web scraping pipeline built using Python, Scrapy, PostgreSQL, and Docker. It extracts data from JSON files, processes it, and stores it in a PostgreSQL database. The entire application is containerized using Docker and orchestrated with Docker Compose. Additionally, it provides functionality to query the database and retrieve the processed data in CSV format.`,
    liveUrl: null,
    githubUrl: "https://github.com/Yakup3/canaria-scrapy",
    tools: ["Python", "Scrapy", "Docker", "PostgreSQL", "Git"],
  },
  {
    title: "Event Management System API",
    description: `This is a back-end API for the Event Management System. The goal of this project is to design and implement a back-end API for an Event Management System using NodeJS, Express and MongoDB.`,
    liveUrl: "https://malwation-backend.glitch.me/",
    githubUrl: "https://github.com/Yakup3/malwation-backend",
    tools: ["Node.js", "Express.js", "Docker", "MongoDB", "Git"],
  },
  {
    title: "Event Management System Frontend",
    description: `The goal of the project is to create a web application where users can log in, view users from the "Users" table, and perform various actions such as updating and deleting users. Additionally, the application also includes functionality to manage events.`,
    liveUrl: "https://malwation-frontend.vercel.app/",
    githubUrl: "https://github.com/Yakup3/malwation-frontend",
    tools: ["React.js", "Material UI", "Css", "Git", "API Integration"],
  },
  {
    title: "Text To Speech",
    description: `The Text-to-Speech Converter is a web application built using React.js that allows users to convert written text into spoken words effortlessly. With a simple and intuitive interface, users can enter the desired text they wish to convert and click the "Play" button to hear it spoken aloud in a natural-sounding voice.`,
    liveUrl: "http://text-to-speech-yakup3.vercel.app/",
    githubUrl: "https://github.com/Yakup3/text-to-speech",
    tools: ["React", "Web Speech API", "JavaScript", "CSS", "Git"],
  },
  {
    title: "Expense Calculator",
    description:
      "The Expense Calculator is a user-friendly mobile application designed to simplify the process of splitting expenses among multiple individuals. Whether you're splitting the bill at a restaurant, sharing household expenses, or managing group finances, this application streamlines the calculation process to ensure fairness and transparency.",
    liveUrl: null,
    githubUrl: "https://github.com/Yakup3/expense-calculator",
    tools: ["React Native", "JavaScript", "Git"],
  },
  {
    title: "TED Talk API",
    description:
      "The TED Talk Data API provides access to a wealth of information related to TED Talks, sourced from the comprehensive TED Talks dataset available on Kaggle. With this API, users can retrieve detailed information about TED Talks, including talk descriptions, related videos, and more. The API enriches the dataset by adding additional key values such as talk ID, thumbnail images, and related embedded video links by scraping each talk's URL using Axios and Cheerio.",
    liveUrl: null,
    githubUrl: "https://github.com/Yakup3/ted-talk-api",
    tools: [
      "Node.js",
      "Express.js",
      "JavaScript",
      "Cheerio",
      "Axios",
      "MongoDB",
      "Git",
    ],
  },
  {
    title: "Fetch Repositories",
    description:
      "This application fetches informations of repositories related to given keyword and prints it on the screen. After fetching data it saves needed informations to PostgreSQL database. Application is developed using django on the backend. On the frontend HTML and CSS is used.",
    liveUrl: null,
    githubUrl: "https://github.com/Yakup3/repo-fetch",
    tools: ["Python", "Django", "HTML", "Css", "PostgreSQL", "Git"],
  },
  {
    title: "Online Maritime Transportation System",
    description:
      "The Maritime Transportation Management System is a comprehensive solution designed to streamline the management of maritime vessels and operations. Leveraging a relational database and a Java-based application, this project offers functionalities for efficiently adding new ships to the database and retrieving information about existing entries.",
    liveUrl: null,
    githubUrl:
      "https://github.com/Yakup3/Online-Maritime-Transportation-System",
    tools: ["Java", "PostgreSQL", "Git"],
  },
  {
    title: "Doodle Jump",
    description:
      "The Simple Doodle Jump Game is an entertaining and addictive platformer game built using Java programming language. Inspired by the popular mobile game, this project offers a fun and challenging gaming experience where players control a character that jumps from platform to platform to reach higher levels.",
    liveUrl: null,
    githubUrl: "https://github.com/Yakup3/Doodle-Jump",
    tools: ["Java", "Git"],
  },
  {
    title: "Premier League Simulation",
    description:
      "The Sports Match Score Calculation and Standings Management System is a comprehensive application designed to automate the process of calculating match scores, managing team standings, and providing real-time updates to the frontend simulation. This application reads data from a file containing scores, team names, and match dates, calculates the scores of each match, updates team standings, saves data to a database, and sends real-time updates to the frontend using Socket.IO for simulation purposes.",
    liveUrl: null,
    githubUrl: "https://github.com/Yakup3/premier-league-simulation",
    tools: [
      "React Native",
      "JavaScript",
      "Expo",
      "RabbitMQ",
      "Socket.io",
      "MongoDB",
      "Node.js",
      "Express.js",
      "Git",
      "API Integration",
    ],
  },
];
